const labels: Record<string, string> = {
  block_time: "Crew block hours",
  flight_time: "Crew flight hours",
  time_out: "Block off",
  time_off: "Takeoff",
  time_on: "Landing",
  time_in: "Block on",
  mission_type: "Mission",
  passenger_count: "Pax #",
  landings_count: "Landings",
  engine_1_n1: "Engine 1 N1",
  engine_1_n2: "Engine 1 N2",
  engine_1_cdv: "Engine 1 CDV",
  engine_2_n1: "Engine 2 N1",
  engine_2_n2: "Engine 2 N2",
  engine_2_cdv: "Engine 2 CDV",
  winch_motor_hours: "Winch motor hours",
  winch_cycles: "Winch cycles",
  night_time: "Crew night hours",
  ifr_time: "Crew IFR hours",
  role: "Crew role",
  family_name: "Crew family name",
  flight_number: "Flight number",
};

/** Read structured validation details, rather than the framework's summary. */
export function logbookSaveError(error: unknown): string {
  const e = error as {
    code?: string;
    issues?: { path?: string; code?: string; message?: string }[];
    results?: { id?: string; messages?: { field?: string; message?: string }[] }[];
  };
  const details: string[] = [];
  const explain = (field: string, message: string) => {
    if (message.includes("requires a crew member with role=TCHEMS")) {
      return "No HEMS technical crew member was imported. Check that a person is selected in the active HEMS-TC seat in duty signing, then reopen this draft.";
    }
    const name = labels[field.replace(/^\//, "")] ?? field.replace(/^\//, "").replace(/_/g, " ");
    const readable = message.replace(/\b[a-z]+(?:_[a-z0-9]+)+\b/g, (key) => labels[key] ?? key.replace(/_/g, " "));
    return name ? `${name}: ${readable}` : readable;
  };
  for (const result of e?.results ?? []) {
    if (result.id === "leg-no-overlapping-siblings") {
      details.push("Block times overlap another flight. Check Block off and Block on against the existing entry.");
    } else {
      for (const issue of result.messages ?? []) {
        if (issue.message) details.push(explain(issue.field ?? "", issue.message));
      }
    }
  }
  for (const issue of e?.issues ?? []) {
    const guidance: Record<string, string> = {
      required: "Enter a value.",
      type: "Enter a valid value.",
      range: "Enter a value within the allowed range.",
      enum: "Choose a value from the list.",
      format: "Check the date or time format.",
    };
    details.push(explain(issue.path ?? "", guidance[issue.code ?? ""] ?? issue.message ?? "Check this value."));
  }
  if (details.length) return "Entry could not be saved. " + [...new Set(details)].join(" ");
  if (e?.code === "SCHEMA_VERSION_MISMATCH")
    return "The logbook database needs an update. Update the app, then try saving again.";
  if (e?.code === "DATABASE_NOT_OPEN" || e?.code === "LOGBOOK_NOT_FOUND")
    return "The logbook database is unavailable. Keep this form open and try again. If it persists, contact support.";
  return "Entry could not be saved because of an unexpected error. Your input is still shown here. Try again; if it persists, contact support with the time and aircraft registration.";
}
